// extracted by mini-css-extract-plugin
export default {"bubbleContainer":"CommentBubble_bubbleContainer__P86KZ","bubbleText":"CommentBubble_bubbleText__i8d8K"};